import ValidationError from './ValidationError';

export default function (res) {
  switch (res.status) {
    case 400:
    case 404:
      return new ValidationError(res);
    case 406:
      return new ValidationError(res);
    default:
      return new Error('Unexpected error');
  }
}



// WEBPACK FOOTER //
// ./src/utilites/networkErrors/index.js